<template>
  <div>
    <SidebarVue ref="sidebar" />
    <Navgator
      ref="navgator"
      :barraTitulo="' Administração - Estoque de Veículos'"
      :titulo="'estoque'"
    />

    <!--Bloco do Filtro-->
    <div class="card-container">
      <div class="card">
        <div class="row g-2 p-2">
          <div class="card-title gy-4">
            <i class="bi bi-funnel fs-5 icon-text-form"></i>
            <span class="txt-title-form">Filtro</span>
          </div>
        </div>
        <div class="row g-2 p-2">
          <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
            <div class="form-floating txt-form-label">
              <input
                type="text"
                class="form-control txt-form-input"
                v-model="filtroPlaca"
                @input="filtrarVeiculos"
              />
              <label>Placa</label>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
            <div class="form-floating txt-form-label">
              <input
                type="text"
                class="form-control txt-form-input"
                v-model="filtroChassi"
                @input="filtrarVeiculos"
              />
              <label>Chassi</label>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
            <div class="form-floating txt-form-label">
              <select class="form-select txt-form-input" v-model="tipoVeiculo">
                <option value="NOVO">Novo</option>
                <option value="USADO">Usado</option>
              </select>
              <label>Tipo Veículo</label>
            </div>
          </div>

          <div class="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
            <div class="form-floating txt-form-label">
              <select
                class="form-select txt-form-input"
                v-model="pageSize"
                @change="handlePageSizeChange(pageSize)"
              >
                <option v-for="size in pageSizes" :key="size" :value="size">
                  {{ size }}
                </option>
              </select>
              <label class="rf_texto">Itens pág.</label>
            </div>
          </div>
          <!-- Seção: Ações -->
          <div class="d-flex justify-content-end gap-2 gap-md-3 mt-4">
            <!-- Botões de Ação - Mobile (apenas ícones) -->
            <div class="d-flex d-md-none gap-2">
              <button
                class="btn round-btn d-flex align-items-center justify-content-center"
                type="button"
                @click="
                  page = 1;
                  retrieveEstoque();
                "
              >
                <i class="bi bi-search" title="Pesquisar"></i>
              </button>
              <button
                class="btn round-btn d-flex align-items-center justify-content-center"
                type="button"
                @click="
                  page = 1;
                  sincronizarEstoque();
                "
              >
                <i class="bi bi-arrow-repeat" title="Sincronizar"></i>
              </button>
            </div>
            <!-- Botões de Ação - Tablet (768px - 991px) -->
            <div class="d-none d-md-flex d-lg-none gap-2">
              <button
                class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                style="font-size: 0.875rem; white-space: nowrap"
                type="button"
                @click="
                  page = 1;
                  retrieveEstoque();
                "
              >
                <span>Pesquisar</span>
              </button>
              <button
                class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                style="font-size: 0.875rem; white-space: nowrap"
                type="button"
                @click="
                  page = 1;
                  sincronizarEstoque();
                "
              >
                <span>Sincronizar Estoque</span>
              </button>
            </div>
            <!-- Botões de Ação - Desktop (≥ 992px) -->
            <div class="d-none d-lg-flex gap-2">
              <button
                class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                style="font-size: 0.875rem; white-space: nowrap"
                type="button"
                @click="
                  page = 1;
                  retrieveEstoque();
                "
              >
                <span>Pesquisar</span>
              </button>
              <button
                class="btn btn-form py-2 px-3 d-inline-flex align-items-center"
                style="font-size: 0.875rem; white-space: nowrap"
                type="button"
                @click="
                  page = 1;
                  sincronizarEstoque();
                "
              >
                <span>Sincronizar Estoque</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Tabelas-->
    <div class="card-container">
      <div class="card">
        <div class="d-md-none">
          <!-- Indicador de Carregamento -->
          <div v-if="isLoading" class="text-center my-4">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Carregando...</span>
            </div>
          </div>
          <div v-else>
            <template v-if="veiculosFiltrados.length === 0">
              <div
                v-for="item in estoque"
                :key="item.modelo"
                class="accordion mb-2"
              >
                <div class="accordion-item">
                  <button
                    class="accordion-button collapsed card-table-txt"
                    data-bs-toggle="collapse"
                    :data-bs-target="'#row-' + item.id"
                  >
                    {{ item.modelo }}
                  </button>
                  <div
                    :id="'row-' + item.id"
                    class="accordion-collapse collapse"
                  >
                    <div class="accordion-body">
                      <p class="card-table-item">
                        <strong>Loja:</strong>
                        {{ item.codigoempresa }}
                      </p>
                      <p class="card-table-item">
                        <strong>Tipo Veículo:</strong>
                        {{ item.estadoveiculo }}
                      </p>
                      <p class="card-table-item">
                        <strong>Marca:</strong>
                        {{ item.marca }}
                      </p>
                      <p class="card-table-item">
                        <strong>Ano Fabricação:</strong>
                        {{ item.anofabricacao }}
                      </p>
                      <p class="card-table-item">
                        <strong>Ano Modelo:</strong>
                        {{ item.anomodelo }}
                      </p>
                      <p class="card-table-item">
                        <strong>Placa:</strong>
                        {{ item.placa }}
                      </p>
                      <p class="card-table-item">
                        <strong>Chassi:</strong>
                        {{ item.chassi }}
                      </p>
                      <p class="card-table-item">
                        <strong>Combustível:</strong>
                        {{ item.combustivel }}
                      </p>
                      <p class="card-table-item">
                        <strong>Cor:</strong>
                        {{ item.cor }}
                      </p>
                      <p class="card-table-item">
                        <strong>Dias em Estoque:</strong>
                        {{ item.diasestoque }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div
                v-for="item in veiculosFiltrados"
                :key="item.modelo"
                class="accordion mb-2"
              >
                <div class="accordion-item">
                  <button
                    class="accordion-button collapsed card-table-txt"
                    data-bs-toggle="collapse"
                    :data-bs-target="'#row-' + item.id"
                  >
                    {{ item.modelo }}
                  </button>
                  <div
                    :id="'row-' + item.id"
                    class="accordion-collapse collapse"
                  >
                    <div class="accordion-body">
                      <p>
                        <strong>Loja:</strong>
                        {{ item.codigoempresa }}
                      </p>
                      <p>
                        <strong>Tipo Veículo:</strong>
                        {{ item.estadoveiculo }}
                      </p>
                      <p>
                        <strong>Marca:</strong>
                        {{ item.marca }}
                      </p>
                      <p>
                        <strong>Ano Fabricação:</strong>
                        {{ item.anofabricacao }}
                      </p>
                      <p>
                        <strong>Ano Modelo:</strong>
                        {{ item.anomodelo }}
                      </p>
                      <p>
                        <strong>Placa:</strong>
                        {{ item.placa }}
                      </p>
                      <p>
                        <strong>Chassi:</strong>
                        {{ item.chassi }}
                      </p>
                      <p>
                        <strong>Combustível:</strong>
                        {{ item.combustivel }}
                      </p>
                      <p>
                        <strong>Cor:</strong>
                        {{ item.cor }}
                      </p>
                      <p>
                        <strong>Dias em Estoque:</strong>
                        {{ item.diasestoque }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="d-none d-md-block d-lg-none">
          <!-- Indicador de Carregamento -->
          <div v-if="isLoading" class="text-center my-4">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Carregando...</span>
            </div>
          </div>
          <div v-else>
            <template v-if="veiculosFiltrados.length === 0">
              <div
                v-for="item in estoque"
                :key="item.modelo"
                class="accordion mb-2"
              >
                <div class="accordion-item">
                  <button
                    class="accordion-button collapsed card-table-txt"
                    data-bs-toggle="collapse"
                    :data-bs-target="'#row-' + item.id"
                  >
                    {{ item.modelo }}
                  </button>
                  <div
                    :id="'row-' + item.id"
                    class="accordion-collapse collapse"
                  >
                    <div class="accordion-body">
                      <p class="card-table-item">
                        <strong>Loja:</strong>
                        {{ item.codigoempresa }}
                      </p>
                      <p class="card-table-item">
                        <strong>Tipo Veículo:</strong>
                        {{ item.estadoveiculo }}
                      </p>
                      <p class="card-table-item">
                        <strong>Marca:</strong>
                        {{ item.marca }}
                      </p>
                      <p class="card-table-item">
                        <strong>Ano Fabricação:</strong>
                        {{ item.anofabricacao }}
                      </p>
                      <p class="card-table-item">
                        <strong>Ano Modelo:</strong>
                        {{ item.anomodelo }}
                      </p>
                      <p class="card-table-item">
                        <strong>Placa:</strong>
                        {{ item.placa }}
                      </p>
                      <p class="card-table-item">
                        <strong>Chassi:</strong>
                        {{ item.chassi }}
                      </p>
                      <p class="card-table-item">
                        <strong>Combustível:</strong>
                        {{ item.combustivel }}
                      </p>
                      <p class="card-table-item">
                        <strong>Cor:</strong>
                        {{ item.cor }}
                      </p>
                      <p class="card-table-item">
                        <strong>Dias em Estoque:</strong>
                        {{ item.diasestoque }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div
                v-for="item in veiculosFiltrados"
                :key="item.modelo"
                class="accordion mb-2"
              >
                <div class="accordion-item">
                  <button
                    class="accordion-button collapsed card-table-txt"
                    data-bs-toggle="collapse"
                    :data-bs-target="'#row-' + item.id"
                  >
                    {{ item.modelo }}
                  </button>
                  <div
                    :id="'row-' + item.id"
                    class="accordion-collapse collapse"
                  >
                    <div class="accordion-body">
                      <p>
                        <strong>Loja:</strong>
                        {{ item.codigoempresa }}
                      </p>
                      <p>
                        <strong>Tipo Veículo:</strong>
                        {{ item.estadoveiculo }}
                      </p>
                      <p>
                        <strong>Marca:</strong>
                        {{ item.marca }}
                      </p>
                      <p>
                        <strong>Ano Fabricação:</strong>
                        {{ item.anofabricacao }}
                      </p>
                      <p>
                        <strong>Ano Modelo:</strong>
                        {{ item.anomodelo }}
                      </p>
                      <p>
                        <strong>Placa:</strong>
                        {{ item.placa }}
                      </p>
                      <p>
                        <strong>Chassi:</strong>
                        {{ item.chassi }}
                      </p>
                      <p>
                        <strong>Combustível:</strong>
                        {{ item.combustivel }}
                      </p>
                      <p>
                        <strong>Cor:</strong>
                        {{ item.cor }}
                      </p>
                      <p>
                        <strong>Dias em Estoque:</strong>
                        {{ item.diasestoque }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="d-none d-lg-block">
          <table class="table rf_texto" v-if="!isLoading">
            <thead>
              <tr>
                <th scope="col">Loja</th>
                <th scope="col">Tipo Veículo</th>
                <th scope="col">Marca</th>
                <th scope="col">Modelo</th>
                <th scope="col">Ano Fab.</th>
                <th scope="col">Ano Mod.</th>
                <th scope="col">Placa</th>
                <th scope="col">Chassi</th>
                <th scope="col">Combustível</th>
                <th scope="col">Cor</th>
                <th scope="col">Dias Estoque</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="veiculosFiltrados.length === 0">
                <tr v-for="item in estoque" :key="item.modelo">
                  <td>{{ item.codigoempresa }}</td>
                  <td>{{ item.estadoveiculo }}</td>
                  <td>{{ item.marca }}</td>
                  <td>{{ item.modelo }}</td>
                  <td>{{ item.anofabricacao }}</td>
                  <td>{{ item.anomodelo }}</td>
                  <td>{{ item.placa }}</td>
                  <td>{{ item.chassi }}</td>
                  <td>{{ item.combustivel }}</td>
                  <td>{{ item.cor }}</td>
                  <td>{{ item.diasestoque }}</td>
                </tr>
              </template>
              <template v-else>
                <tr v-for="item in veiculosFiltrados" :key="item.modelo">
                  <td>{{ item.codigoempresa }}</td>
                  <td>{{ item.estadoveiculo }}</td>
                  <td>{{ item.marca }}</td>
                  <td>{{ item.modelo }}</td>
                  <td>{{ item.anofabricacao }}</td>
                  <td>{{ item.anomodelo }}</td>
                  <td>{{ item.placa }}</td>
                  <td>{{ item.chassi }}</td>
                  <td>{{ item.combustivel }}</td>
                  <td>{{ item.cor }}</td>
                  <td>{{ item.diasestoque }}</td>
                </tr>
              </template>
            </tbody>
          </table>
          <div v-else class="loading-indicator">Carregando...</div>
        </div>
        <pagination
          v-if="estoque.length"
          :total="totalItems"
          :limit="pageSize"
          :offset="currentPage"
          :totalPages="Math.ceil(totalItems / pageSize)"
          @change-page="handlePageChange"
        />
      </div>
    </div>

    <div v-if="abrir_modal">
      <Message :msg="msg" v-show="msg" />
    </div>
    <RodapeVue />
  </div>
</template>
<script>
import SidebarVue from "../../components/menu/Sidebar.vue";
import userService from "../../services/user.service";
import Pagination from "../../components/Pagination.vue";
import Message from "../../components/modal/Message.vue";
import TokenService from "../../services/token.service";
import jwt_decode from "jwt-decode";
import RodapeVue from "../../components/menu/Rodape.vue";
import Navgator from "../../components/menu/Navgator.vue";

export default {
  components: {
    SidebarVue,
    Navgator,
    Pagination,
    Message,
    RodapeVue
  },
  data() {
    return {
      isLoading: false,
      estoque: [],
      //Mensagens do Sistema
      msg: null,
      abrir_modal: false,

      tipoVeiculo: "",

      //Params
      filtroPlaca: "", // Filtro para a placa
      filtroChassi: "", // Filtro para o número
      filtroCategoria: "", // Filtro para a categoria
      veiculosFiltrados: [],
      page: 1,
      totalPages: 0,
      totalItems: 0,
      pageSizes: [25, 50, 75, 100],
      pageSize: 25,
      company_id: ""
    };
  },
  mounted() {
    this.getToken();
    this.retrieveEstoque();
  },
  methods: {
    getToken() {
      const accessToken = TokenService.getLocalAccessToken();

      // Obter o token de atualização (refresh token)
      TokenService.getLocalRefreshToken();

      // Obter o usuário completo (incluindo os tokens) se necessário
      TokenService.getUser();

      const decodedToken = jwt_decode(accessToken);

      this.company_id = decodedToken.company;
    },
    getStatus(status) {
      return status === 0 ? "Desabilitado" : "Habilitado";
    },
    getVendaFut(vendaFutura) {
      return vendaFutura === 0 ? "Não" : "Sim";
    },

    filtrarVeiculos() {
      // Acessar o array subjacente usando Array.from() ou spread operator
      const estoqueArray = Array.from(this.estoque); // ou const estoqueArray = [...this.estoque];

      // Verificar se ambos os filtros estão vazios
      if (!this.filtroPlaca && !this.filtroChassi) {
        // Se ambos estiverem vazios, mostrar todos os veículos
        this.veiculos = estoqueArray;
        return;
      }
      // Aplicar os filtros
      let veiculosFiltrados = estoqueArray.filter((estoque) => {
        let passouFiltroPlaca = true;
        let passouFiltroNumero = true;

        // Aplicar filtro da placa, se fornecido
        if (this.filtroPlaca) {
          passouFiltroPlaca = estoque.placa
            .toLowerCase()
            .includes(this.filtroPlaca.toLowerCase());
        }

        // Aplicar filtro do número, se fornecido
        if (this.filtroChassi) {
          passouFiltroNumero = estoque.chassi
            .toLowerCase()
            .includes(this.filtroChassi.toLowerCase());
        }

        // Retornar verdadeiro se o veículo passar por todos os filtros
        return passouFiltroPlaca && passouFiltroNumero;
      });

      // Atualizar os dados da tabela com os veículos filtrados
      this.estoque = veiculosFiltrados;
    },

    getRequestParams(
      searchPlaca,
      searchChassi,
      tipoVeiculo,
      page,
      pageSize,
      company_id
    ) {
      let params = {};

      if (tipoVeiculo) {
        params["tipoVeiculo"] = tipoVeiculo;
      }

      if (searchPlaca) {
        params["placa"] = searchPlaca;
      }
      if (searchChassi) {
        params["chassi"] = searchChassi;
      }

      if (page) {
        params["page"] = page - 1;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      if (company_id) {
        params["empresa_id"] = company_id;
      }
      return params;
    },
    async handlePageChange(newPage) {
      if (this.isLoading) return;

      this.isLoading = true;
      try {
        await this.retrieveEstoque(newPage);
        this.page = newPage;
      } finally {
        this.isLoading = false;
      }
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.retrieveEstoque();
    },

    async retrieveEstoque(page = this.page) {
      try {
        const params = this.getRequestParams(
          this.searchPlaca,
          this.searchChassi,
          this.tipoVeiculo,
          page,
          this.pageSize,
          this.company_id
        );

        const response = await userService.getEstoqueVeiculo(params);
        const { veiculoEstoque, totalPages, totalItems } = response.data;

        this.estoque = veiculoEstoque;
        this.totalPages = totalPages;
        this.totalItems = totalItems;
        this.veiculosFiltrados = [];
        return true; // Indica sucesso
      } catch (error) {
        console.error("Erro ao buscar clientes:", error);
        if (error.response?.status === 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
        return false; // Indica falha
      }
    },

    async sincronizarEstoque() {
      try {
        userService.getEstoqueSincronizar().then((response) => {
          const { message } = response.data;
          this.abrir_modal = true;
          this.msg = message;
          setTimeout(() => (this.abrir_modal = false), 4000);
          this.retrieveEstoque();
        });
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
      }
    }
  }
};
</script>
